'use strict';

angular.module('enervexSalesappApp').service('HubspotDealsService', function(HubspotDeal, Job, $stateParams) {
	this.getJob = getJob;
	this.getHubspotDeal = getHubspotDeal;
	this.saveHubspotDeal = saveHubspotDeal;
	this.sync = sync;
	this.proposalAmount = proposalAmount;
	this.searchContacts = searchContacts;
	this.createContact = createContact;

	function getJob() {
		return Job.get({
			id: $stateParams.jobId,
			accountId: $stateParams.accountId
		});
	}

	function getHubspotDeal() {
		return HubspotDeal.get({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId
		});
	}

	/**
	 * A pinned proposal version reads history, so the page cannot work its total
	 * out on its own -- ask the server for it.
	 */
	function proposalAmount(proposalId, version) {
		return HubspotDeal.proposalAmount({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId,
			proposal: proposalId,
			version: (version === null || version === undefined) ? '' : version
		});
	}

	function saveHubspotDeal(payload) {
		return HubspotDeal.save({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId
		}, payload);
	}

	function sync() {
		return HubspotDeal.sync({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId
		}, {});
	}

	function searchContacts(term) {
		return HubspotDeal.searchContacts({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId,
			q: term
		});
	}

	function createContact(payload) {
		return HubspotDeal.createContact({
			accountId: $stateParams.accountId,
			jobId: $stateParams.jobId
		}, payload);
	}
});
